import React, { useEffect, useState } from "react";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import { Volume2Icon } from "lucide-react";
import { greetings } from "../../data/greetings";
import { spring } from "../../utils/motion";
import { speak } from "../../utils/speech";
export function CyclingGreeting() {
  const [index, setIndex] = useState(0);
  const [speaking, setSpeaking] = useState(false);
  const reduce = useReducedMotion() ?? false;
  const current = greetings[index];
  useEffect(() => {
    if (speaking || reduce) return;
    const id = window.setInterval(() => setIndex(i => (i + 1) % greetings.length), 2400);
    return () => window.clearInterval(id);
  }, [speaking, reduce]);
  return <motion.button type="button" onClick={() => speak(current.word, current.lang, {
    onStart: () => setSpeaking(true),
    onEnd: () => setSpeaking(false)
  })} whileHover={reduce ? undefined : {
    scale: 1.03
  }} whileTap={{
    scale: 0.96
  }} transition={spring.snappy} title={`Hear it in ${current.language}`} className="relative mx-1 inline-block cursor-pointer rounded-2xl align-baseline outline-none focus-visible:outline focus-visible:outline-[3px] focus-visible:outline-offset-[6px] focus-visible:outline-brand" data-id="element-814" data-mp="1jwrq6gygia47">
      <span className={`relative inline-grid overflow-hidden rounded-2xl border-3 border-line px-3 pb-2 pt-1 text-[0.85em] shadow-brutal transition-colors duration-150 sm:px-4 md:rounded-card md:px-6 ${speaking ? "bg-brand text-white" : "bg-accent text-night"}`} data-id="element-815" data-mp="2ao905xtdzxfi">
        {greetings.map(g => <span key={g.word} aria-hidden="true" className="invisible whitespace-nowrap [grid-area:1/1]" data-id="element-816" data-mp="2ycjxiqzvjez1">
            {g.word}
          </span>)}
        <AnimatePresence initial={false} data-id="element-817" data-mp="1myeovkopugxd">
          <motion.span key={current.word} lang={current.lang} initial={reduce ? {
          opacity: 0
        } : {
          y: "90%",
          opacity: 0,
          rotate: 4
        }} animate={{
          y: 0,
          opacity: 1,
          rotate: 0
        }} exit={reduce ? {
          opacity: 0
        } : {
          y: "-90%",
          opacity: 0,
          rotate: -4
        }} transition={reduce ? {
          duration: 0.15
        } : spring.bouncy} className="absolute inset-x-0 bottom-2 top-1 flex items-center justify-center whitespace-nowrap" data-id="element-818" data-mp="1mzhd1kunm59l">
            {current.word}
          </motion.span>
        </AnimatePresence>
      </span>
      <span className="absolute -bottom-3 right-3 flex items-center gap-1 rounded-md border-2 border-line bg-ink px-2 py-0.5 text-[11px] font-semibold uppercase leading-none tracking-wide text-paper md:text-xs" data-id="element-819" data-mp="3mh1acoqhzjd1">
        <Volume2Icon className="h-3 w-3 md:h-3.5 md:w-3.5" strokeWidth={3} aria-hidden="true" data-id="element-820" data-mp="3dhnxdm360cnk" />
        {current.language}
        <span className="sr-only" data-id="element-821" data-mp="3ig7pk48cqkod">, tap to hear it</span>
      </span>
    </motion.button>;
}